import { useEffect, useRef, useState } from 'react';
import { api } from '../api';

interface UndoItem { key: string; label: string; ids: string[]; busy: boolean; error: string }
export function useDeleteUndo(onRestored: (restored: number, remaining: number) => Promise<void>) {
  const [items, setItems] = useState<UndoItem[]>([]);
  const busy = useRef(new Set<string>());
  const onRestoredRef = useRef(onRestored);
  useEffect(() => { onRestoredRef.current = onRestored; }, [onRestored]);
  const add = (ids: string[], label: string) => { if (ids.length) setItems((current) => [...current, { key: crypto.randomUUID(), label, ids, busy: false, error: '' }]); };
  const restore = async (key: string) => {
    if (busy.current.has(key)) return;
    const item = items.find((candidate) => candidate.key === key);
    if (!item) return;
    busy.current.add(key);
    setItems((current) => current.map((entry) => entry.key === key ? { ...entry, busy: true, error: '' } : entry));
    const failed: string[] = [];
    for (const id of item.ids) {
      try { await api(`/api/events/${encodeURIComponent(id)}/restore`, { method: 'POST' }); }
      catch { failed.push(id); }
    }
    setItems((current) => failed.length ? current.map((entry) => entry.key === key ? { ...entry, ids: failed, busy: false, error: `${failed.length}件を戻せませんでした。もう一度お試しください。` } : entry) : current.filter((entry) => entry.key !== key));
    busy.current.delete(key);
    await onRestoredRef.current(item.ids.length - failed.length, failed.length);
  };
  return { items, add, restore };
}
